import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { Avatar } from '@mui/material';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import globals from '../../globals';

function TestimonialsDgn({ name, pic, quote, city }) {

    return (
        <Card sx={{ width: 350, height: 350, borderRadius: 3, justifyContent: 'center'}}>
                <CardContent>
                        <Grid display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
                            {/* <Avatar alt='ivan' src={pic} sx={{alignSelf: "center", width: 70, height: 70, position:'absolute', top:-5}} /> */}
                        </Grid>
                    <Typography gutterBottom textAlign={'center'} sx={{mt:3, fontSize: 20, color: globals.colors.darkBlue, fontWeight: 'bold'}}>
                        {name}
                    </Typography>
                    <Typography gutterBottom textAlign={'center'} sx={{mb:3, fontSize: 14}}>
                        {city}
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                        {quote}
                    </Typography>
                </CardContent>
        </Card>
    );
}

export default TestimonialsDgn;
